import { jsxs, jsx } from "react/jsx-runtime";
import { useColors } from "@inbody/core";
import { Box, CircularProgress } from "@mui/material";
import { createButtonSx } from "../tokens.js";
function FormButton({
  label,
  onClick,
  variant = "primary",
  size = "md",
  radius,
  fullWidth = false,
  disabled = false,
  startIcon,
  endIcon,
  loading = false,
  loadingLabel,
  sx,
  type = "button",
  form
}) {
  const { gray, brand, base } = useColors();
  const buttonSx = createButtonSx({
    gray,
    brand,
    base,
    variant,
    size,
    radius,
    fullWidth
  });
  const isDisabled = disabled || loading;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      component: "button",
      type,
      form,
      disabled: isDisabled,
      onClick: isDisabled ? void 0 : onClick,
      sx: {
        border: "none",
        ...buttonSx,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.75,
        cursor: isDisabled ? "not-allowed" : "pointer",
        fontFamily: "inherit",
        lineHeight: 1,
        whiteSpace: "nowrap",
        outline: "none",
        ...sx
      },
      children: [
        loading ? /* @__PURE__ */ jsx(CircularProgress, { size: 14, color: "inherit", sx: { flexShrink: 0 } }) : startIcon ? /* @__PURE__ */ jsx(
          Box,
          {
            component: "span",
            sx: { display: "inline-flex", fontSize: 0, flexShrink: 0 },
            children: startIcon
          }
        ) : null,
        loading && loadingLabel ? loadingLabel : label,
        !loading && endIcon && /* @__PURE__ */ jsx(
          Box,
          {
            component: "span",
            sx: { display: "inline-flex", fontSize: 0, flexShrink: 0 },
            children: endIcon
          }
        )
      ]
    }
  );
}
export {
  FormButton
};
